<template>
  <div id="password_reset_form">
    <h3 class="mb-4">
      {{ set_password ? "Set your Password" : "Reset your Password" }}
    </h3>
    <form class="kt-form" data-vv-scope="reset_password_form" @submit.prevent="resetPassword()">
      <input type="hidden" name="_token" :value="csrf">
      <input type="hidden" name="token" :value="csrf">

      <div v-if="success">
        <div class="alert alert-success" role="alert">
          {{ success }}
        </div>
      </div>

      <div v-if="error">
        <div class="alert alert-danger" role="alert">
          {{ error }}
        </div>
      </div>

      <div class="form-group">
        <input id="email" v-model="form.email"
               v-validate="'required|email'"
               type="email"
               class="form-control"
               name="email" required
               placeholder="Email Address..."
               autocomplete="email" autofocus>
        <p v-show="errors.has('email', 'reset_password_form')" class="validation-error help kt-font-danger">
          {{ errors.first('email', 'reset_password_form') }}
        </p>
      </div>

      <div class="form-group">
        <input ref="password" v-model="form.password"
               v-validate.continues="'required|min:8|has_lc_alpha|has_uc_alpha|has_digit|has_special'" type="password"
               name="password"
               class="form-control kt-input"
               placeholder="Password" autocomplete="off"
               aria-describedby="basic-addon1">

        <ul v-show="errors.has('password', 'reset_password_form')" class="validation-error help text-ss-danger">
          <li v-for="(err, index) in errors.collect(`password`, 'reset_password_form')" :key="index">
            {{ err }}
          </li>
        </ul>
      </div>

      <div class="form-group">
        <input ref="password_confirmation"
               v-model="form.password_confirmation"
               v-validate.continues="'required|confirmed:password'"
               data-vv-as="password confirmation"
               type="password" name="password_confirmation"
               class="form-control kt-input" placeholder="Confirm Password"
               autocomplete="off" aria-describedby="basic-addon1">

        <p v-show="errors.has('password_confirmation', 'reset_password_form')"
           class="validation-error help text-ss-danger">
          {{ errors.first('password_confirmation', 'reset_password_form') }}
        </p>
      </div>

      <div class="form-group mb-0">
        <div class="">
          <button class="btn btn-ss" type="button" @click="showForm('login_form')">
            Back
          </button>
          <button id="reset_submit" type="submit" class="btn btn-ss-standout">
            {{ set_password ? "Set Password" : "Reset Password" }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import AuthFormsMixin from "VueMixins/AuthFormsMixin";
export default {
  mixins: [AuthFormsMixin],
  data() {
    return {
      set_password: window.set_password,
      reset_token: window.reset_token,
      form: {
        email: null,
        password: null,
        password_confirmation: null,
      },
    };
  },
  methods: {
    async resetPassword() {
      this.laddaButton("reset_submit");
      const form_data = {
        password: this.form.password,
        password_confirmation: this.form.password_confirmation,
        token: this.reset_token,
        email: this.form.email,
        _token: window.csrfToken,
      };

      this.$validator.validateAll('reset_password_form').then((result) => {
        if (result) {
          axios.post('/password/reset', form_data).then(() => {
            if (this.set_password) {
              this.setSuccess("Password Set. Logging you in...");
            } else {
              this.setSuccess("Password Reset. Logging you in...");
            }
            window.location.href = "/";
            this.unLaddaButton("reset_submit");
          }).catch(() => {
            if (this.set_password) {
              this.setError("Unable to set password. Token may have expired, or email address is incorrect. Please click the reset password link and try again.");
            } else {
              this.setError("Unable to reset password. Token may have expired, or email address is incorrect.");
            }

            this.unLaddaButton("reset_submit");
          });
        } else {
          this.unLaddaButton("reset_submit");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .validation-error {
   text-align:left;
    margin-top: 1rem;
  }
</style>
